export default __webpack_public_path__ + "static/media/I878.c209deac.jpg";